import { render } from "./GestioneCampiForm.vue?vue&type=template&id=0cf91c37&scoped=true"
import script from "./GestioneCampiForm.vue?vue&type=script&lang=js"
export * from "./GestioneCampiForm.vue?vue&type=script&lang=js"

import "./GestioneCampiForm.vue?vue&type=style&index=0&id=0cf91c37&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cf91c37"]])

export default __exports__